import React from "react";

export const Privacy = (props) => {
  return (
    <div id="privacy" className="text-center">
      <div className="container">
        <div className="section-title">
          <h2>隱私政策</h2>
          <p>
            歡迎加入「贏很大 Online」下稱「我們」或「本公司」，為了保障您的線上隱私，讓您能夠安心使用本應用程式為您所提供的各項遊戲與服務，我們在此向您說明本應用程式的隱私條款，並告知個人資料保護法規定之事項，幫助您了解當您使用本應用程式的各項遊戲與服務時，對於您個人資料處理的原則與政策，以及資料蒐集及利用的範圍與目的，以期讓您明瞭我們對您所提供的任何資料，是絕對保護及尊重！
          </p>
        </div>
        <div className="row">
          <h6>A.個人資料之蒐集政策</h6>
          <ol>
            <li>蒐集之目的：090消費者、客戶管理與服務。</li>
            <li>個人資料之類別：姓名、住址、電話、電子郵件地址、網路平臺申請之帳號、相片、身分證統一編號、出生年月日、結婚有無、配偶及父母之姓名、以及其它任何可辨識您本人之資料。
            </li>
            <li>當您選擇使用第三方提供之身分驗證機制（例如LINE帳號、Facebook帳號、Google帳號等方式）申請成為本應用程式之會員，我們會透過該身分驗證機制取得您在該等帳號中同意揭露之個人資訊。
            </li>
            <li>除了上述資訊外，如果您透過官方聯絡渠道反應您的意見或詢問相關業務問題，我們會保存您的通訊記錄。我們也會保留您在使用本應用程式時，由伺服器自動進行的相關記錄，包括連線設備的IP位址、使用時間、使用的裝置、作業系統類型及版本編號、實際位置、瀏覽及點選資料紀錄等。
            </li>
            <li>個人資料利用之期間、地區、對象及方式：
              <ol>
                <li>期間：蒐集目的之存續期間或相關法令規定之保存期限，以較長者為準。</li>
                <li>地區：除蒐集目的涉及國際業務或活動外，本公司僅於中華民國領域內利用您的個人資料。</li>
                <li>對象及方式：本公司僅對蒐集目的所必要之對象，以合理方式利用您的個人資料。</li>
              </ol>
            </li>
            <li>您可透過官方聯絡渠道向本公司行使下列權利：
              <ol>
                <li>查詢或請求閱覽。</li>
                <li>請求製給複製本。</li>
                <li>請求補充或更正。</li>
                <li>請求停止蒐集、處理及利用。</li>
                <li>請求刪除您的個人資料。</li>
              </ol>
            </li>
            <li>您依前項規定查詢或請求閱覽個人資料或製給複製本時，本公司得酌收必要成本費用。根據部分服務現行的運作機制，在刪除您的個人資訊後，系統需要一段時間才會將殘留的檔案副本從線上伺服器中完全刪除，而我們的備份系統仍可能保留其檔案備份。
            </li>
            <li>您可自由選擇是否提供個人資料。如您選擇不提供個人資料，我們將無法為您提供本應用程式之相關服務。</li>
          </ol>
          <h6>B.第三方蒐集</h6>
          <p>請您注意，與本應用程式連結的其它網站或服務，也可能蒐集您的個人資料。對於您主動提供的個人資訊，這些連結網站應有其個別的隱私政策，其資料處理措施不適用本隱私條款，且本公司不負任何連帶責任。
          </p>
          <h6>C.個人資料之利用政策</h6>
          <p>本公司所蒐集的個人資料，將依蒐集之特定目的，做為提供服務、寄發電子報、提供技術資訊、提供市場資訊等之用。除法令或本隱私條款另有規定外，本公司不會對個人資料為蒐集之特定目的外之利用，亦不會任意對其他第三者揭露。
          </p>
          <h6>D.與第三者共用個人資料之政策</h6>
          <p>我們絕對不會任意出售、交換、出租或以其他變相之方式，將您的個人資料揭露予其他團體或個人。惟有下列三種情形，我們會與第三者共用您的個人資料。
          </p>
          <ol>
            <li>經過您的事前同意或授權允許時。</li>
            <li>司法單位或其他主管機關經合法正式的程序要求時。</li>
            <li>為了提供您其他服務或優惠權益，需要與提供該服務或優惠之第三者共用您的資料時，本公司會在活動內容中充分說明並告知您可以自由選擇是否接受該項服務或優惠。
            </li>
          </ol>
          <h6>E.傳送商業資訊之政策</h6>
          <p>本公司將在事前或註冊登錄取得您的同意後，傳送相關商業資訊給您。本公司除了在該資料上註明是由我們發送，也會在該資料上提供您能隨時停止接收這些資料的方法、說明或功能連結。
          </p>
          <h6>F.COOKIES的運用與政策</h6>
          <p>COOKIES是伺服端為了區別使用者的不同喜好，經由瀏覽器寫入使用者硬碟的一些簡短資訊。您可以修改您使用之瀏覽器對COOKIES的接受程度。本公司利用COOKIES記錄您登入網站後的相關操作，並可能以之作為爭議處理的參考資料。如果您選擇拒絕所有的COOKIES，您就可能無法使用部份個人化服務，或是參與部份的活動。
          </p>
          <h6>G.自我保護措施</h6>
          <p>請妥善保管您的憑證、密碼或任何個人資料，不要將任何個人資料，尤其是帳號及密碼提供給任何人或其他機構。在您使用完本應用程式所提供的各項服務功能後，請務必記得登出帳號，若您是與他人共享電腦或使用公共電腦，切記要關閉瀏覽器視窗，以防止他人讀取您的個人資料
          </p>
          <h6>H.隱私權保護政策修訂</h6>
          <p>藉由使用本應用程式或在線上提供您的資訊給我們，視為您接受我們在本隱私條款中所述之隱私權保護政策。我們會不定時修訂本隱私條款，以符合最新之隱私權保護規範。當我們修改本隱私條款時，我們會在本應用程式中以及網頁上張貼告示，通知您相關事項。如果您對本隱私條款有任何疑問，歡迎隨時從官方聯絡渠道與我們聯絡。
          </p>
        </div>
      </div>
    </div>
  );
};
